export default __webpack_public_path__ + "static/flutter-sviluppo-custom-1ca379c7b9efe7b1b3ee0a9b09e88b5e.jpg";